import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from '@mui/material/Alert';
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";

import { VariableSizeList as List } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";

import axios from "../components/Axios";
import "./Logo.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      errorMessage: "",
      email: "",
      password: "",
      remember: false,
      images: [],
      rowMaxHeight: 450,
    };

    this.categories = {
      1: "person",
      2: "bicycle",
      3: "car",
      4: "motorcycle",
      5: "airplane",
      6: "bus",
      7: "train",
      8: "truck",
      9: "boat",
      10: "traffic light",
      11: "fire hydrant",
      13: "stop sign",
      14: "parking meter",
      15: "bench",
      16: "bird",
      17: "cat",
      18: "dog",
      19: "horse",
      20: "sheep",
      21: "cow",
      22: "elephant",
      23: "bear",
      24: "zebra",
      25: "giraffe",
      27: "backpack",
      28: "umbrella",
      31: "handbag",
      32: "tie",
      33: "suitcase",
      34: "frisbee",
      35: "skis",
      36: "snowboard",
      37: "sports ball",
      38: "kite",
      39: "baseball bat",
      40: "baseball glove",
      41: "skateboard",
      42: "surfboard",
      43: "tennis racket",
      44: "bottle",
      46: "wine glass",
      47: "cup",
      48: "fork",
      49: "knife",
      50: "spoon",
      51: "bowl",
      52: "banana",
      53: "apple",
      54: "sandwich",
      55: "orange",
      56: "broccoli",
      57: "carrot",
      58: "hot dog",
      59: "pizza",
      60: "donut",
      61: "cake",
      62: "chair",
      63: "couch",
      64: "potted plant",
      65: "bed",
      67: "dining table",
      70: "toilet",
      72: "tv",
      73: "laptop",
      74: "mouse",
      75: "remote",
      76: "keyboard",
      77: "cell phone",
      78: "microwave",
      79: "oven",
      80: "toaster",
      81: "sink",
      82: "refrigerator",
      84: "book",
      85: "clock",
      86: "vase",
      87: "scissors",
      88: "teddy bear",
      89: "hair drier",
      90: "toothbrush",
    };
  }

  componentDidMount() {
    //remember
    axios
      .get(window.location.origin + "/json/coco/coco_val_469.json")
      .then(
        function (response) {
          this.setState({ images: response.data }, function () {
            //this.getDetections();
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          //this.setState({ loading: false });
        }.bind(this)
      );
  }

  getDetections() {
    let exp = new URLSearchParams(this.props.location.search).get("exp");
    if (exp == null) exp = 81;

    axios
      .get(window.location.origin + "/json/coco/res.json")
      .then(
        function (response) {
          this.setState(
            function (state) {
              for (let i in response.data) {
                if (state.images[i].image_id == response.data[i].image_id)
                  state.images[i].detections = response.data[i].detections;
                else
                  console.log(
                    "diff image_id",
                    state.images[i],
                    response.data[i]
                  );
              }

              return state;
            },
            function () {
              this.setState({ loading: false });
            }
          );
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          //this.setState({ loading: false });
        }.bind(this)
      );
  }

  getItemSize(index) {
    let h = parseInt(this.state.images[index].height);
    if (h > this.state.rowMaxHeight) h = this.state.rowMaxHeight;
    return h;
  }

  getRowStyle(index, style) {
    let h = parseInt(this.state.images[index].height);
    if (h > this.state.rowMaxHeight) {
      let s = this.state.rowMaxHeight / h;
      return { ...style, transform: `scale(${s}, ${s})` };
    } else return style;
  }

  getBBoxStyle(bbox) {
    return {
      left: parseInt(bbox[0]),
      top: parseInt(bbox[1]),
      width: bbox[2],
      height: bbox[3],
    };
  }

  render() {
    return (
      <div className="logoBackground">
        <AutoSizer>
          {({ height, width }) => (
            <List
              height={height}
              width={width}
              itemCount={this.state.images.length}
              itemSize={this.getItemSize.bind(this)}
              overscanCount={4}
            >
              {({ index, style }) => (
                <div className="logoRow" style={this.getRowStyle(index, style)}>
                  <div className="logoImgDiv">
                    <img src={this.state.images[index].coco_url}></img>
                    <div className="rowNum">{index}.</div>
                    {this.state.images[index].gt.map((box, i) => (
                      <div
                        key={"img" + index + "_bbox" + i}
                        className="bbox_gt"
                        title={this.categories[box["category_id"]]}
                        style={this.getBBoxStyle(box.bbox)}
                      />
                    ))}
                  </div>
                  {
                    <div className="logoImgDiv">
                      <img src={this.state.images[index].coco_url}></img>
                      {this.state.images[index].detections.map((d, i) => (
                        <div
                          key={"img" + index + "_det_bbox" + i}
                          className="bbox_pred"
                          title={
                            this.categories[d["category_id"]] + ": " + d.score
                          }
                          style={this.getBBoxStyle(d.bbox)}
                        >
                          {this.categories[d["category_id"]]}{" "}
                          {parseFloat(d.score).toFixed(3)}
                        </div>
                      ))}
                    </div>
                  }
                </div>
              )}
            </List>
          )}
        </AutoSizer>
      </div>
    );
  }
}

export default withRouter(Index);
